import { useQuery } from "@tanstack/react-query";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Breadcrumb } from "@/components/Breadcrumb";
import { TablaPuestos } from "./TablaPuestos";

export function GestionPuestosPage() {
	return (
		<div id="content" className="content" >
			<title>Piher | Gestión de puestos</title>
			<Breadcrumb
				sectionTitle="Gestión de subpuestos"
				links={[
					{ label: "Gestión de subpuestos", active: true }
				]}
			/>

			<div className="box-shadow panel-box panel-info">
				<h4><strong>Info</strong></h4>
				Aquí podrá encontrar el listado de los puestos activos en el EKON, y podrá gestionar los subpuestos que contiene cada uno pinchando sobre
				el icono + en la fila correspondiente. Además, se visualizarán los operarios asignados a ese puesto
			</div>

			<TablaPuestos />
		</div>
	);
}

export function usePuestos() {
	return useQuery<Puesto[]>({
		queryKey: ["puestos"],
		queryFn: () => {
			const url = "/api/v1/puestos";
			return sendAjaxRequest<Puesto[]>("GET", url);
		},
	});
}

export interface Puesto {
	idMaquina: string;
	nombreMaquina: string,
	operarios: string,
}